import { REQUEST, SUCCESS, ERROR, ROOT } from './types'

const state = () => ({
  user: {},
  loading: false,
  error: ''
})

const getters = {
  user: (state) => state.user || {},
  policies: (state) => [
    ...(state.user?.groups
      ?.flatMap(g => g.roles)
      ?.flatMap(r => r.policies) || []),
    ...(state.user?.roles
      ?.flatMap(r => r.policies) || []),
    ...(state.user?.policies || [])
  ],
  loading: (state) => state.loading,
  error: (state) => state.error,
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
  },
  [REQUEST](state) {
    state.loading = true
  },
  [SUCCESS](state) {
    state.loading = false
    state.error = ''
  },
  [ERROR](state, error) {
    state.error = error
    state.loading = false
  }
}

const actions = {
  async login({ commit, dispatch, state }, payload) {
    if (state.loading) return
    commit(REQUEST)

    const token = localStorage.getItem(`token`)

    const res = await dispatch(`api`, {
      entity: `authentication`,
      action: token ? `refresh` : `signIn`,
      payload
    }, ROOT)

    if (!res) {
      commit(ERROR, `Serviço indisponível no momento. Tente novamente mais tarde.`)
    } else if (res.status < 400) {
      localStorage.setItem(`token`, res.data.token)
      commit(`SET_USER`, res.data.user || res.data.body)
      commit(SUCCESS)
    } else {
      localStorage.clear()
      commit(ERROR, res.data.error || `Não foi possível realizar login.`)
    }
  }
}


export default {
  namespaced: true,
  state: state(),
  getters,
  mutations,
  actions
}
